import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import MainSidebar from '../components/MainSidebar';
import rightarrow from '../assets/images/right.svg';
import config from '../config/config';

const TwoStep = () => {
  const [userData, setUserData] = useState({ email: '', user_name: '' });
  const [twoStepAuthEnabled, setTwoStepAuthEnabled] = useState(false);
  const [secretKey, setSecretKey] = useState('');
  const [authCode, setAuthCode] = useState('');
  const [message, setMessage] = useState('');
  const [qrCode, setQrCode] = useState('');
  const [isAuthSetupComplete, setIsAuthSetupComplete] = useState(false); 
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/Login');
      return;
    }

    const fetchUserDetails = async () => {
      try {
        const response = await axios.get(`${config.baseURL}/current-user-details`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const user = response.data.data.user;
        setUserData(user);
        setTwoStepAuthEnabled(user.topt_auth_status === 'true');
      } catch (error) {
        console.error('Error fetching user details', error);
      }
    };

    fetchUserDetails();
  }, [navigate]);

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleTwoStepAuthChange = async (event) => {
    const token = localStorage.getItem('token');
    const enabled = event.target.checked;

    try {
      const response = await axios.post(`${config.baseURL}/update-topt-auth`, { enabled }, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (enabled) {
        setSecretKey(response.data.data.secret);
        const qrCodeUrl = response.data.data.qr_code || '';
        setQrCode(qrCodeUrl);
        setMessage('Two-Step Authentication enabled successfully!');
      } else {
        setSecretKey('');
        setQrCode('');
        setMessage('Two-Step Authentication disabled successfully!');
      }

      setTwoStepAuthEnabled(enabled);
    } catch (error) {
      console.error('Error updating Two Step Authentication settings', error);
      setMessage('Error updating settings. Please try again.');
    }

    // Clear message after 3 seconds
    setTimeout(() => setMessage(''), 3000);
  };

  const handleEnableTwoFactor = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.post(`${config.baseURL}/verify-totp`, { verification_code: authCode }, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      if (response.data.success) {
        setMessage('Two-Step Authentication enabled successfully!');
        setTwoStepAuthEnabled(true);
        setIsAuthSetupComplete(true);
      } else {
        setMessage('Failed to enable Two-Step Authentication. Please try again.');
      }
      setAuthCode('');
    } catch (error) {
      setMessage(error.response?.data?.message || 'Error enabling Two-Step Authentication');
      console.error('Error enabling Two-Step Authentication', error);
    }

    // Clear message after 3 seconds
    setTimeout(() => setMessage(''), 3000);
  };

  return (
    <div>
      <div className="main_patreonpass_wrapper">
        <div className="patreonpass_container">
          <div className="left_sidebar">
            <MainSidebar />
          </div>
          <div className="patreonpass_main_content edit_profile_settings" id="content">
            <div className="left_main_content">
              <div className="feed_wrapper">
                <div className="page_title_with_dropdown notification_page">
                  <div className="page_heading">
                    <button className="profile_back_btn" onClick={handleBackClick}>
                      <svg width={54} height={54} viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M48 27.5363L5.99998 27.5363M5.99998 27.5363L27 49.0532M5.99998 27.5363L27 6.3032" stroke="#222" strokeWidth={6} strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                    <h1>SETTINGS</h1>
                  </div>
                </div>
                <div className="menus_all_wrapper">
                  <div className="edit_settings_menu_list">
                    <h3><a href={`/${userData.user_name}`}>@{userData.user_name}</a></h3>
                    <ul>
                      <li><Link to="/EditProfile">Profile <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                      <li><Link className="active_profile_menu" to="/AccountSettings">Account <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                      <li><Link to="/PrivacySafetySettings">Privacy and safety <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                      <li><Link to="/NotificationSettings">Notifications <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="right_main_content">
              <div className="page_title_with_dropdown notification_page">
                <div className="page_heading">
                  <button className="profile_back_btn" onClick={handleBackClick}>
                    <svg width={54} height={54} viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M48 27.5363L5.99998 27.5363M5.99998 27.5363L27 49.0532M5.99998 27.5363L27 6.3032" stroke="#222" strokeWidth={6} strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>
                  <h1>Two Step Authentication</h1>
                </div>
              </div>
              <div className="edit_username_field with_top_fixed_heading privacysafetysettings">
                <div className="fields_menu_bottom_box_security">
                  <div className="edit_settings_menu_list_without_link">
                    <ul>
                      <li>
                        <div className="switcher-content">
                          <label htmlFor="twoStepAuthToggle"> Authenticator App</label>
                          <input
                            type="checkbox"
                            id="twoStepAuthToggle"
                            checked={twoStepAuthEnabled}
                            onChange={handleTwoStepAuthChange}
                          />
                          <label htmlFor="twoStepAuthToggle" className="switch" />
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                {twoStepAuthEnabled && !isAuthSetupComplete && userData.topt_auth_status !== 'true' && (
                  <div className="authenticator-setup">
                    <h5>Authenticator App Setup</h5>
                    <p>
                      1. Download and install Microsoft or Google Authenticator app from 
                      <a href="https://play.google.com" target="_blank" rel="noopener noreferrer"> Google Play</a>{" "}
                      or <a href="https://www.apple.com/app-store/" target="_blank" rel="noopener noreferrer">App Store</a>
                    </p>
                    <p>
                      2. In the app, open “Settings” and select “Set up account”
                    </p>
                    <p>3. Select “Scan a barcode” or “Enter provided key”</p>
                    <div className="row mt-3">
                      <div className="col-4 text-center">
                        <img
                          src={qrCode || 'https://via.placeholder.com/120'}
                          alt="QR Code"
                          className="qr-code"
                        />
                      </div>
                      <div className="col-8 auth-key-container">
                        <div className="auth-key">{secretKey}</div>
                        <p>
                          <button 
                            className="text-primary" 
                            onClick={() => {
                              navigator.clipboard.writeText(secretKey)
                                .then(() => {
                                  setMessage('Key copied to clipboard!');
                                })
                                .catch((err) => {
                                  console.error('Could not copy text: ', err);
                                  setMessage('Failed to copy key.');
                                });
                              // Clear message after 3 seconds
                              setTimeout(() => setMessage(''), 3000);
                            }}
                          >
                            COPY KEY
                          </button>
                        </p>
                      </div>
                    </div>
                    <div className="auth-code-input">
                      <label htmlFor="authenticatorCode" className="form-label">
                        Enter code from your Microsoft or Google Authenticator
                      </label>
                      <input
                        type="text"
                        id="authenticatorCode"
                        className="form-control"
                        placeholder="Authenticator code"
                        value={authCode}
                        onChange={(e) => setAuthCode(e.target.value)}
                      />
                    </div>
                    <button 
                      className="btn btn-primary w-100 mt-3" 
                      onClick={handleEnableTwoFactor} 
                      disabled={!authCode}
                    >
                      ENABLE
                    </button>
                  </div>
                )}

                {message && <div className="alert alert-success">{message}</div>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TwoStep;
